import React, { useState, useEffect } from 'react'

const withState = WrappedComponent => {
  return props => {
    const [selectedGradeId, setSelectedGradeId] = useState(null)

    useEffect(() => setSelectedGradeId(null), [])

    return (
      <WrappedComponent
        setSelectedGradeId={setSelectedGradeId}
        selectedGradeId={selectedGradeId}
        {...props}
      />
    )
  }
}

export default withState
